import Vue from 'vue'
import App from './App.vue'
import router from './router'
var VueScrollTo = require('vue-scrollto');

Vue.config.productionTip = false

new Vue({
  router,
  VueScrollTo,
  render: h => h(App)
}).$mount('#app')
